import React from 'react';
import c from '../w.js';

const IconCheckboxSelected = React.memo(
  c(
    /* @__PURE__ */ React.createElement(
      "path",
      {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M5 2C3.34315 2 2 3.34315 2 5V19C2 20.6569 3.34315 22 5 22H19C20.6569 22 22 20.6569 22 19V5C22 3.34315 20.6569 2 19 2H5ZM11.2071 16.2071L17.7071 9.70711L16.2929 8.29289L10.5 14.0858L7.20711 10.7929L5.79289 12.2071L9.79289 16.2071L10.5 16.9142L11.2071 16.2071Z"
      }
    )
  )
);

export { IconCheckboxSelected };
